import { FormEvent, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { appsService, AppMetadata } from '../services/appsService';

import Loader from './Loader';

const AppsDiscover = () => {
  const { user } = useAuth();
  const [apps, setApps] = useState<AppMetadata[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchApps = (query?: string) => {
    if (!user) return;
    setLoading(true);
    setError(null);
    appsService
      .list({ per_page: 6, search: query })
      .then((response) => setApps(response.data.apps))
      .catch((err) => setError(err instanceof Error ? err.message : 'Failed to load apps'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchApps();
  }, [user]);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    fetchApps(search || undefined);
  };

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h3>Discover apps</h3>
          <p style={{ color: 'var(--gray)' }}>Approve Gate.haus apps to connect your identity.</p>
        </div>
        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '0.5rem' }}>
          <input
            type="search"
            placeholder="e.g. Gate Mail"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <button type="submit">Search</button>
        </form>
      </div>
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
          <Loader />
        </div>
      )}
      {error && <p style={{ color: 'var(--danger)' }}>{error}</p>}
      {!loading && !error && (
        <div className="dashboard-grid">
          {apps.map((app) => (
            <div
              key={app.id}
              style={{
                border: `1px solid ${app.colour || 'var(--border)'}`,
                padding: '1.25rem',
                borderRadius: '16px'
              }}
            >
              <strong>{app.name}</strong>
              <p style={{ color: 'var(--gray)' }}>{app.description}</p>
              {app.homepage_url && (
                <a href={app.homepage_url} target="_blank" rel="noreferrer">
                Visit site
                </a>
              )}
            </div>
          ))}
          {apps.length === 0 && <p>No apps found.</p>}
        </div>
      )}
    </div>
  );
};

export default AppsDiscover;
